// extracted by mini-css-extract-plugin
module.exports = {"one-video":"OneVideo_one-video__ZV2O_","full-width":"OneVideo_full-width__uFwyR","video-container":"OneVideo_video-container__FCzra"};